import mitt from 'mitt'

import { Confirm } from '@/types/general'
import { DashboardWidget } from '@/types/dashboard'

export type Events = {
    fetchTours: void
    fetchTransactions: void
    fetchReceipts: void
    fetchDriverReports: void
    fetchDamageReports: void
    incidentFixed: void
    showConfirm: Confirm
    fetchAlarms: void
    fetchShipments: void
    fetchTickets: void
    fetchDeviations: void
    fetchChecklists: void
    deleteWidget: DashboardWidget
    fetchWidgetData: void
    fetchPackagingOrders: void
    fetchLoadingLists: void
    fetchDefaultRemarks: void
    printLoadingLists: void
    openDeviationModal: string
}

// Global event bus to emit events across the entire application
export const emitter = mitt<Events>()
